module.exports = __webpack_public_path__ + "static/hofsteestichting-96bfd0a5b1d988888177e4f946e8c60c.png";